import { useEffect } from "react";
import AOS from "aos";
import Typed from "typed.js";
import Isotope from "isotope-layout";
import imagesLoaded from "imagesloaded";

const useInitScripts = () => {
  useEffect(() => {
    // Init AOS
    AOS.init({
      duration: 600,
      easing: "ease-in-out",
      once: true,
      mirror: false,
    });

    // Init Typed.js (Animation de texte)
    const selectTyped = document.querySelector(".typed");
    if (selectTyped) {
      let typedStrings = selectTyped.getAttribute("data-typed-items");
      typedStrings = typedStrings.split(",");
      new Typed(".typed", {
        strings: typedStrings,
        loop: true,
        typeSpeed: 100,
        backSpeed: 50,
        backDelay: 2000,
      });
    }


    // Init Isotope Layout & Filters
    const isotopeItems = document.querySelectorAll(".isotope-layout");
    isotopeItems.forEach((isotopeItem) => {
      let layout = isotopeItem.getAttribute("data-layout") ?? "masonry";
      let filter = isotopeItem.getAttribute("data-default-filter") ?? "*";
      let sort = isotopeItem.getAttribute("data-sort") ?? "original-order";

      imagesLoaded(isotopeItem.querySelector(".isotope-container"), () => {
        let initIsotope = new Isotope(isotopeItem.querySelector(".isotope-container"), {
          itemSelector: ".isotope-item",
          layoutMode: layout,
          filter: filter,
          sortBy: sort,
        });

        isotopeItem.querySelectorAll(".isotope-filters li").forEach((filterEl) => {
          filterEl.addEventListener("click", function () {
            isotopeItem.querySelector(".isotope-filters .filter-active").classList.remove("filter-active");
            this.classList.add("filter-active");
            initIsotope.arrange({ filter: this.getAttribute("data-filter") });
          });
        });
      });
    });

    // Scroll Behavior
    const handleScroll = () => {
      if (window.scrollY > 100) {
        document.body.classList.add("scrolled");
      } else {
        document.body.classList.remove("scrolled");
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
};

export default useInitScripts;
